import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { ExpandComponent } from '../../expand/expand.component';
import { NavigationMenuService } from '../../../services/navigation-menu/navigation-menu.service';
import { MenuItem } from '../../../interfaces/menu.interface';
import { ElementTypes, GaContext } from '../../../interfaces/gtm.interface';

@Component({
  selector: 'fin-light-section-navi',
  styleUrls: ['./light-section-navi.component.scss'],
  templateUrl: './light-section-navi.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LightSectionNaviComponent {
  private navigationMenuService = inject(NavigationMenuService);

  readonly ElementTypes = ElementTypes;
  readonly activeNaviSection$: Observable<MenuItem>;
  readonly activeNaviItem$: Observable<MenuItem>;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly TRACKING_CONTEXT = GaContext.SECTION_NAVIGATION;

  constructor() {
    this.activeNaviSection$ = this.navigationMenuService.activeNaviSection;
    this.activeNaviItem$ = this.navigationMenuService.activeNaviItem;
  }

  trackItems(index: number): number {
    return index;
  }

  toggleDetails(expandComponent: ExpandComponent, external: boolean): void {
    if (!external) {
      expandComponent.toggleDetails();
    }
  }
}
